module.exports = __webpack_public_path__ + "img/back.8a9e8432.svg";